import { render, staticRenderFns } from "./viewIncomeType.vue?vue&type=template&id=7cb70406&scoped=true&"
import script from "./viewIncomeType.vue?vue&type=script&lang=js&"
export * from "./viewIncomeType.vue?vue&type=script&lang=js&"
import style0 from "./viewIncomeType.vue?vue&type=style&index=0&id=7cb70406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb70406",
  null
  
)

export default component.exports